import axios from "axios";
import { api } from "~/router/apiConfig";

export function list(query = null) {
  return axios.get(api.path("userHistory.index"), { params: query });
}
